import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as T from "utils/types";
import * as API from 'app/public_api';

export const cntPerPage = 10;

const initList = createAsyncThunk(
    'rsrTab/initList', 
    async (data:{
        keywordType: T.keywordType,
        searchInput: T.searchInput,
        acceptingGraduateStudentChecked: boolean,
        C3IChecked: boolean,
        facultyID: number,
        departmentID: number,
        SDGs: number[]
    }, thunkAPI)=>{
        const {
            searchInput, keywordType, acceptingGraduateStudentChecked, C3IChecked,
            departmentID, facultyID,
            SDGs
        }=data;
        const {currentPage, }= (thunkAPI.getState() as T.RootState).rsrTab;
        return await API.rRsrList(
            searchInput,
            keywordType,
            currentPage+1,
            departmentID,
            facultyID,
            acceptingGraduateStudentChecked,
            C3IChecked,
            SDGs
        );
    }
)

const loadMore = createAsyncThunk(
    'rsrTab/loadMore', 
    async (data, thunkAPI)=>{
        const {
            searchInput, 
            keywordType,
            departmentID,
            facultyID,
            rsrSpecific: {
                acceptingGraduateStudentChecked,
                C3IChecked,
                SDGs
            }
        }= (thunkAPI.getState() as T.RootState).searchPgUserInputs;
        const {currentPage, }= (thunkAPI.getState() as T.RootState).rsrTab;
        return await API.rRsrList(
            searchInput,
            keywordType,
            currentPage+1,
            departmentID,
            facultyID,
            acceptingGraduateStudentChecked,
            C3IChecked,
            SDGs
        );
    }
)

export const rsrTabThunks = {initList, loadMore};

export const initialState: T.RsrTab = {
    total: -1, // means the total is not known
    rsrList: [],
    currentPage: 0,
    hasNext: true,
    status: 'idle',
    errorMsg: null,
    currentRequestId: null
}

const rsrTabS = createSlice({
    name: 'rsrTab',
    initialState,
    reducers: {},
    extraReducers: builder=>{

        // firstLoad thunk
        builder.addCase(initList.pending, (state, action) => {

            state.currentPage = initialState.currentPage;
            state.hasNext = initialState.hasNext;
            state.total = initialState.total;

            state.status = 'loading';
            state.errorMsg = initialState.errorMsg;
            state.currentRequestId = action.meta.requestId;

            // init the list to be cntPerPage skeleton items
            state.rsrList =  [
                ...new Array(cntPerPage)
            ].map(()=>({loading: true, item: null})) ;
        });
        builder.addCase(initList.fulfilled, (state, action) => {
            // below line makes sure the response comes from the most recent request
            if(action.meta.requestId===state.currentRequestId){
                state.status = 'succeeded';

                const {links, total_result, results} = action.payload            

                state.total = total_result;
                state.hasNext = !!links.next;
                state.currentPage += 1;

                state.rsrList = results.map(
                    x=>({loading:false, item: x}
                ));
            }
        });
        builder.addCase(initList.rejected, (state, action) => {
            // below line makes sure the response comes from the most recent request
            if(action.meta.requestId===state.currentRequestId){
                state.status = 'failed';
                state.errorMsg = action.error.message;
            }
        });




        // loadMore thunk
        builder.addCase(loadMore.pending, (state, action) => {
            state.status = 'loading';

            // add cntPerPage skeleton items to the list
            state.rsrList = state.rsrList.concat( 
                [...new Array(cntPerPage)].map(()=>({loading:true, item: null}))
            );
        });
        builder.addCase(loadMore.fulfilled, (state, action) => {
            state.status = 'succeeded';

            const {links, total_result, results} = action.payload            

            state.total = total_result;
            state.hasNext = !!links.next;
            state.currentPage += 1;

            // replace the last cntPerPage skeleton item list 
            // to the list we received
            state.rsrList = state.rsrList.slice(0, -cntPerPage).concat( 
                results.map(x=>({loading:false, item: x}))
            );
        });
        builder.addCase(loadMore.rejected, (state, action) => {
            state.status = 'failed';
            state.errorMsg = action.error.message;
        });

    }
});

export default rsrTabS;